import React, { useEffect, useState } from "react";
import style from "./MainPage.module.css";
import IntroPage from "./IntroPage/IntroPage";
import ProjectTable from "../ProjectTable/ProjectTable";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import {
  setBugViewMode,
  setIsBugDashboard,
  setIsBugPage,
  setSelectedProject,
  setSelectedProjectBugs,
  setIsBugSummaryModal,
  setCurrentBugDetails,
  setSelectedBugSummary,
  setLoading,
} from "../../store/slice/bugSlice";
import { setIsProjectSetup } from "../../store/slice/setupSlice";
import {
  setSelectedClient,
  setSelectedClientProjects,
  setLoading as setClientLoading,
} from "../../store/slice/clientSlice";
import {
  getBugDetails,
  getBugsByProjId,
  getDashboardByProjId,
  getProjectByClientId,
  getFeatureByProjId
} from "../../services/homeService";
import { setDashboardDataByprojId } from "../../store/slice/dashboardSlice";
import Header from "../../Components/Navbar/Header";

const MainPage = () => {
  const { selectedClient, selectedClientProjects } = useSelector((state) => {
    return state.clientDetails;
  });
  const { clientId, projectId, bugId } = useParams();
  const { isBugDashboard, isBugPage, selectedProject, bugViewMode } =
    useSelector((state) => {
      return state.bugDetails;
    });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const getProjectByClientIdApi = async (id) => {
    try {
      // Check if we already have projects for this client in Redux
      const hasProjectsForClient = selectedClientProjects && 
                                  selectedClientProjects.length > 0 && 
                                  selectedClientProjects[0]?.clientId === parseInt(id);
      
      if (hasProjectsForClient) {
        console.log("Using cached projects from Redux store");
        // We already have the projects in Redux, no need to fetch
        return;
      }

      // If not in Redux, fetch from API
      dispatch(setClientLoading(true));
      const resp = await getProjectByClientId(id);
      dispatch(setSelectedClientProjects(resp));
      dispatch(setClientLoading(false));
    } catch (error) {
      console.error("Error fetching projects:", error.message);
      dispatch(setClientLoading(false));
    }
  };

  const getBugDetailsApi = async (id) => {
    try {
      const resp = await getBugDetails(id);
      dispatch(setCurrentBugDetails(resp));
    } catch (error) {
      console.error("Error fetching clients:", error.message);
    }
  };
  useEffect(() => {
    if (!location || !location.pathname) return;
    const hasAddBug = location.pathname.includes("/addBug");
    const isDashboard = location.pathname.includes("/dashboard");
    const isFeature = location.pathname.includes("/feature");
    const hasBugs = location.pathname.includes("/bugs");
    if (location.pathname === "/") {
      dispatch(setSelectedClient(null));
      dispatch(setIsBugPage(false));
      dispatch(setIsBugDashboard(false));
      dispatch(setIsBugSummaryModal(false));
      dispatch(setIsProjectSetup(false));
    } else if (clientId && !projectId) {
      dispatch(setIsBugPage(false));
      dispatch(setIsBugDashboard(false));
      dispatch(setSelectedProject({}));
      dispatch(setIsBugSummaryModal(false));
      dispatch(
        setSelectedClient({
          label: location?.state?.clientName,
          value: clientId,
        })
      );
      getProjectByClientIdApi(clientId);
      dispatch(setIsProjectSetup(false));
    } else if (
      projectId &&
      !bugId &&
      !hasAddBug &&
      !isDashboard &&
      !isFeature &&
      !hasBugs
    ) {
      dispatch(
        setSelectedProject({
          ...selectedProject,
          id: projectId,
          name: location.state?.projectName,
          clientId,
        })
      );
      dispatch(
        setSelectedClient({
          label: location?.state?.clientName,
          value: clientId,
        })
      );
      // getBugsByProjIdApi(projectId, location?.state?.paramName);
      dispatch(setIsBugSummaryModal(false));
      dispatch(setIsProjectSetup(false));
      dispatch(setBugViewMode(false));
      dispatch(setSelectedBugSummary([]));
      getFeatureByprojectIdApi(projectId)
    } else if (bugId || hasAddBug) {
      dispatch(
        setSelectedClient({
          label: location?.state?.clientName,
          value: clientId,
        })
      );
      dispatch(
        setSelectedProject({
          ...selectedProject,
          id: projectId,
          name: location.state?.projectName,
          clientId,
        })
      );
      // getBugsByProjIdApi(projectId);
      dispatch(setIsBugPage(true));
      dispatch(setIsBugSummaryModal(true));
      if (hasAddBug) {
        dispatch(setCurrentBugDetails([]));
        dispatch(setBugViewMode(false));
      }
      if (bugId) {
        getBugDetailsApi(bugId);
        dispatch(setBugViewMode(true));
      }
    } else if (hasBugs) {
      dispatch(
        setSelectedClient({
          label: location?.state?.clientName,
          value: clientId,
        })
      );
      dispatch(
        setSelectedProject({
          ...selectedProject,
          id: projectId,
          name: location.state?.projectName,
          clientId,
        })
      );
      dispatch(setIsBugPage(true));
      dispatch(setIsBugSummaryModal(false));
      dispatch(setBugViewMode(false));
      dispatch(setSelectedBugSummary([]));
      // Don't fetch bugs again here - they're already filtered and set by SubtasksPage
    } else if (isDashboard) {
      dispatch(
        setSelectedClient({
          label: location?.state?.clientName,
          value: clientId,
        })
      );
      dispatch(
        setSelectedProject({
          ...selectedProject,
          id: projectId,
          name: location.state?.projectName,
          clientId,
        })
      );

      getProjectByClientIdApi(clientId);
      dispatch(setIsBugDashboard(true));

      getDashboardByProjId(projectId).then((resp) =>
        dispatch(setDashboardDataByprojId(resp))
      );
    } else if (isFeature) {
      dispatch(
        setSelectedClient({
          label: location?.state?.clientName,
          value: clientId,
        })
      );
      dispatch(
        setSelectedProject({
          ...selectedProject,
          id: projectId,
          name: location.state?.projectName,
          clientId,
        })
      );
      getProjectByClientIdApi(clientId);
      dispatch(setIsBugDashboard(false));
      dispatch(setIsProjectSetup(true));
    }
  }, [location?.pathname, clientId, projectId, bugViewMode]);

  const filterBugsByEntryName = (bugs, entryName) => {
    switch (entryName) {
      case "Low":
      case "Medium":
      case "High":
      case "Critical":
        return bugs?.filter((item) => item?.bugSummary?.severity === entryName);
      case "Open":
      case "In Progress":
      case "Resolved":
      case "Close":
        return bugs?.filter((item) => item?.status?.value === entryName);
      default:
        return bugs;
    }
  };
  const getBugsByProjIdApi = async (selectedProjectId, entryName) => {
    try {
      setLoading(true);
      const resp = await getBugsByProjId(selectedProjectId);
      setLoading(false);
      const filteredData = filterBugsByEntryName(resp, entryName);
    
      // dispatch(setSelectedProjectBugs(filteredData));
    } catch (error) {
      console.error("Error fetching clients:", error.message);
    }
  };
  const getFeatureByprojectIdApi = async (selectedProjectId) => {
    try {
      const resp = await getFeatureByProjId(selectedProjectId);

      if(resp.length){
        dispatch(setIsBugPage(true));
      }else{
        dispatch(setIsBugPage(false));
        const state = { clientName: selectedClient.label};
        navigate(`./client/${clientId}`, { state });
      }
    } catch (error) {
      console.error("Error fetching clients:", error.message);
    }
  };

  return (
    <>
      <Header />
      <div className={style.mainPage} id="main-page">
        {selectedClient?.value ? <ProjectTable /> : <IntroPage />}
      </div>
    </>
  );
};
export default MainPage;
